import {Component, Input, OnInit} from '@angular/core';
import {MatIconButton} from '@angular/material/button';
import {MatDialog} from '@angular/material/dialog';
import {MatSuffix} from '@angular/material/form-field';
import {MatIcon} from '@angular/material/icon';
import {FilterDialogComponent} from '@app/assetfilter/filter-dialog/filter-dialog.component';
import {SearchComponent} from '@app/assetfilter/search/search.component';

@Component({
    selector: 'frog-filter-panel-button',
    templateUrl: './filter-panel-button.component.html',
    styleUrls: ['./filter-panel-button.component.scss'],
    imports: [MatIconButton, MatSuffix, MatIcon],
})
export class FilterPanelButtonComponent implements OnInit {
    @Input() search: SearchComponent;

    constructor(private matDialog: MatDialog) {}

    ngOnInit(): void {}

    openFilterPanel() {
        this.matDialog.open(FilterDialogComponent, {
            backdropClass: 'filter-panel-backdrop',
            position: {
                top: '64px',
                left: `${parseInt(this.search.input.nativeElement.getBoundingClientRect().x)}px`,
            },
            width: `${this.search.input.nativeElement.clientWidth}px`,
        });
    }
}
